import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AsyncReduxState, initialAsyncReduxState } from '../../../redux/@config/AsyncReduxState'
import { UserWithHourBalances } from '../../entities/HourBalances/HourBalances'

export type HourBalancesState = AsyncReduxState<{
    hourBalances: UserWithHourBalances[];
}>;

const initialState: HourBalancesState = {
    ...initialAsyncReduxState,
    hourBalances: [],
}

export const hourBalancesSlice = createSlice({
    name: 'hourBalancesReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): HourBalancesState {
            return {
                ...state,
                isLoading: action.payload,
            }
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): HourBalancesState {
            return {
                ...state,
                isSuccessful: action.payload,
            }
        },
        setError(state, action: PayloadAction<string>): HourBalancesState {
            return {
                ...state,
                error: action.payload,
            }
        },
        setHourBalances(state, action: PayloadAction<UserWithHourBalances[]>): HourBalancesState {
            return {
                ...state,
                hourBalances: action.payload,
            }
        },
    },
})

export const {
    setIsLoading,
    setIsSuccessful,
    setError,
    setHourBalances,
} = hourBalancesSlice.actions

export default hourBalancesSlice.reducer
